export const SOFT_DELETE_PREDICATE = { deletedAt: { isNull: true } } as const;
